import { render, staticRenderFns } from "./StockAdjusts.vue?vue&type=template&id=a38b691e&"
import script from "./StockAdjusts.vue?vue&type=script&lang=js&"
export * from "./StockAdjusts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports